import { useForm } from "react-hook-form";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid } from "@mui/material";
import { yupResolver } from '@hookform/resolvers/yup';
import { InputController } from "@shared/ui/form";
import { ErrorAlert, SuccessAlert } from "@shared/ui/alerts";
import i18next from "i18next";

import { sendAutomaticInvoicePublic } from "../api/invoiceApi";
import { sendAutomaticInvoicePublicSchema } from "../schema/sendAutomaticInvoicePublicSchema";

import type { SendInvoiceTokenRequest } from "../api/invoiceApi";
import type { SendAutomaticInvoicePublicValues } from "../schema/sendAutomaticInvoicePublicSchema";

export interface SendAutomaticInvoicePublicProps {
    handleClose: () => void;
    open: boolean;
    notLoading: () => void;
    loading: () => void;
    token: string;
    id: number;
}

export const SendAutomaticInvoicePublic = ({handleClose, open, notLoading, loading, token, id}: SendAutomaticInvoicePublicProps) => {
    const {control, handleSubmit, reset, formState: {errors}} = useForm<SendAutomaticInvoicePublicValues>({
        resolver: yupResolver(sendAutomaticInvoicePublicSchema) as never,
    });

    const onClose = () => {
        handleClose()
    }
    const onRegister = (value: SendAutomaticInvoicePublicValues) => {
        loading()
        onClose()
        const payload: SendInvoiceTokenRequest = { ...value, token, userId: id };
        sendAutomaticInvoicePublic(payload).then(() => {
            notLoading()
            SuccessAlert("Carga de Factura", "Realizada con Exito").then()
        }).catch((error) => {
            const data = error.response?.data;
            notLoading()
            ErrorAlert("Error al Cargar Factura", data?.message ?? i18next.t("internalError")).then()
        })
    }

    return (
        <>
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                <form onSubmit={handleSubmit(onRegister)}>
                    <DialogTitle>Carga de Factura Automatica</DialogTitle>
                    <DialogContent>
                        <Box sx={{ p: 1 }}>
                            <Grid container spacing={3}>
                                <Grid size={12}>
                                    <FormControl fullWidth>
                                        <InputController name="ccEmail" control={control}
                                                         type="email"
                                                         defaultValue="" label="Correo de Copia"/>
                                        {errors.ccEmail &&
                                        <span style={{fontSize: 12, color: "red"}}>{errors.ccEmail.message}</span>}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose}>Cancelar</Button>
                        <Button type="submit">Cargar</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
